import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isLoggedIn } from "../utils/utils";

const Dashboardoutlet = () => {
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log(isLoggedIn())
  //   !isLoggedIn() && navigate("/login");
  // }, []);
  return (
    <div>
 
      <Outlet />
    </div>
  );
};

export default Dashboardoutlet;
